//@flow

import styled from "styled-components"

export const SliderContainer = styled.div`
  background: rgba(32, 32, 32, 0.8);
  display: flex;
  min-height: 170px;
  position: absolute;
  border-radius: 2rem;
  bottom: 3rem;
  left: 3rem;
  right: 3rem;
  z-index: 2;
`

export const Track = styled.ul`
  list-style: none;
  position: absolute;
  height: 3px;
  top: 50%;
  margin: -10px 0 0 0;
  padding: 0;
  left: 4rem;
  right: 4rem;
  background: #fff;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  pointer-events: none;
`

export const Segment = styled.li`
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  flex-basis: 100px;
  width: 100px;
  flex-shrink: 0;
  flex-grow: 0;
  margin: 0 auto;

  &:first-child {
    margin-left: -50px;
  }
  &:last-child {
    margin-right: -50px;
  }
`

export const Label = styled.span`
  text-transform: uppercase;
  text-align: center;
  font-family: "din-condensed";
  font-size: 24px;
  margin: 10px auto 0 auto;
  color: #fff;
  font-weight: 300;
  pointer-events: none;
`

export const Notch = styled.span`
  display: block;
  height: 44px;
  background: rgba(152, 152, 152, 1);
  margin: 0 auto;
  width: 1px;
  pointer-events: none;
`

export const Thumb = styled.button`
  background: #25beaecc;
  border: none;
  height: 108px;
  width: 108px;
  position: absolute;
  top: 50%;
  left: 4rem;
  margin-top: -64px;
  margin-left: -54px;
  border-radius: 54px;
  z-index: 2;
  display: flex;
`

export const ThumbContent = styled.span`
  margin: auto;
  display: block;
  height: 36px;
  width: 36px;
  pointer-events: none;
`



// WEBPACK FOOTER //
// ./src/Kiosk/WoodburningView/Slider/UI.js